import request from "./api";
/**
 *    achievement 真实任务api
 *                         Author by zyp. on 2020.06.22
 *
 * */
//  学生 获取subjectId
export const getSubjectId = (id,params, opts) =>
    request('/api-course/class/query'+id, params, {
        ...opts,
        // method: 'post'
    });
//  学生 获取postList
export const getPost = (id,params, opts) =>
    request('/api-course/team/find/myStation'+id, params, {
        ...opts,
        // method: 'post'
    });
//  学生 获取任务列表
export const getRealTaskList = (params, opts) =>
    request('/api-study/api/teamTask/find', params, {
        ...opts,
        method: 'post'
    });
//  学生 获取公司列表
export const getCompanyList = (id,params, opts) =>
    request('/api-course/realTaskPush/'+id, params, {
        ...opts,
        // method: 'post'
    });
//  学生 获取状态列表
export const getStateList = (id,params, opts) =>
    request('/api-resource/taskFlow/find'+id, params, {
        ...opts,
        // method: 'post'
    });
//  学生 获取进度接口
export const getTeskProgress = (id,params, opts) =>
    request('/api-study/api/teamTask/find/progress'+id, params, {
        ...opts,
        // method: 'post'
    });
//  学生 获取进度接口
export const getTeskRecord = (params, opts) =>
    request('/api-study/api/teamTask/find/teamTask/record', params, {
        ...opts,
        method: 'post'
    });
//  学生 任务处理
export const realTeskhandler = (params, opts) =>
    request('/api-study/api/teamTask/handler', params, {
        ...opts,
        method: 'post'
    });

//  学生 查看消息
export const getTeskmsg = (id ,params, opts) =>
    request('/api-study/api/teamTask/find/taskMsg'+id, params, {
        ...opts,
        // method: 'post'
    });
//  学生 三天下跳转 axios 写的

//  学生 查询上一岗位
export const realTaskPreviousCompany = (id,params, opts) =>
    request('/api-study/api/teamTask/find/prev'+id, params, {
        ...opts,
        // method: 'post'
    });
//  学生 退回
export const realTaskfallback = (params, opts) =>
    request('/api-study/api/teamTask/fallback', params, {
        ...opts,
        method: 'post'
    });
//  学生 提交任务
export const submitTask= (params, opts) =>
    request('/api-study/api/teamTask/submit', params, {
        ...opts,
        method: 'post'
    });

//  任务新推送数量
export const getRealTaskNum= (params, opts) =>
    request('/api-study/api/teamTask/findAuditNum', params, {
        ...opts,
        method: 'post'
    });



// WEBPACK FOOTER //
// ./src/api/realTaskApi.js